// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { Field } from 'redux-form'
import { RadioGroup } from 'components/Form'

const options = [{
  label: 'LF',
  value: 'LF',
}, {
  label: 'RF',
  value: 'RF',
}, {
  label: 'Any',
  value: '',
}]

const FeedDirection = ({ idRoot }) => (
  <Field
    idRoot={`${idRoot}feed-direction`}
    className={'feed-direction-radio horiz-labels styled-radio small-styled-radio text-white uppercase'}
    component={RadioGroup}
    name={'feedDir'}
    options={options} />
)

export default FeedDirection
